import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box } from "@mui/material";
import { TFunction } from "i18next";
import React from "react";
import NoInvoicesFoundV2 from "./NoInvoicesFoundV2";
import ErrorPage from "../../../../components/ErrorPage/ErrorPage";

const NoRowsAvailableError = (
  error: boolean,
  t: TFunction<string[], undefined>,
  reloadCallback: () => void,
  areInvoiceFilterQueryParametersSameAsFilter: boolean
) => (
  <Box
    sx={{
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {error ? (
        <ErrorPage
          title={t("common:technicalError.title")}
          subtitles={[t("common:technicalError.subtitle")]}
          icon={{ Component: WarningAmberIcon, color: "warning" }}
          showBackToHomeLink
          showReloadBtn
          reloadFunction={reloadCallback}
        />
      ) : (
        <NoInvoicesFoundV2
          doesFilterMatchFilterQueryParameters={
            areInvoiceFilterQueryParametersSameAsFilter
          }
        />
      )}
    </Box>
  </Box>
);

export default NoRowsAvailableError;
